<template>
  <div
    :class="{ 'h5-promotion-images': isH5, 'pc-promotion-images': !isH5 }"
    class="promotion-images"
  >
    <!-- <p class="content-title">{{ moduleInfo.module_title }}</p> -->
    <!-- 轮播图 -->
    <div v-if="moduleInfo.content_style === 1" class="swiper-container">
      <el-skeleton v-if="false" animated>
        <template slot="template">
          <el-skeleton-item
            variant="image"
            :style="[{ height: skeleton.swiperHeight + 'px' }]"
          />
        </template>
      </el-skeleton>
      <swiper
        :options="handleSwiperOption"
        ref="mySwiper"
        class="swiper-container"
      >
        <swiper-slide v-for="item in moduleInfo.content_list" :key="item.id">
          <picture>
            <div class="wrap-image">
              <img
                class="swiper-img"
                :src="item.cover_url + '?imageView2/0/w/1000'"
                :jump_url="item.jump_url"
              />
            </div>
          </picture>
        </swiper-slide>
        <div
          class="swiper-button-prev"
          slot="button-prev"
          v-show="moduleInfo.content_list.length > 1"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          v-show="moduleInfo.content_list.length > 1"
        ></div>
        <div
          class="swiper-pagination"
          slot="pagination"
          v-show="moduleInfo.content_list.length > 1"
        ></div>
      </swiper>
    </div>
    <!-- 平铺 -->
    <div v-else class="images-list">
      <img
        v-for="item in moduleInfo.content_list"
        :key="item.id"
        :src="item.cover_url + '?imageView2/0/w/1000'"
        @click="jumpUrl(item.jump_url)"
      />
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disableOperation: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    let _this = this;
    return {
      isH5: isH5(),
      content_style: {
        1: "轮播",
        2: "单图排列",
      },
      swiperOption: {
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
        },
        grabCursor: true,
        loop: true,
        speed: 1000,
        clickable: true,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          click: function (e) {
            if (_this.disableOperation) return;
            let jumpUrl = e.target.getAttribute("jump_url");
            if (jumpUrl) {
              if (window.isElectron) {
                window.openUrlByExternal(jumpUrl);
              } else {
                window.open(jumpUrl);
              }
            }
          },
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {},
  methods: {
    jumpUrl(url) {
      window.open(url);
    },
  },
  computed: {
    handleSwiperOption() {
      if (this.moduleInfo?.content_list?.length > 1) {
        return this.swiperOption;
      } else {
        let option = { ...this.swiperOption };
        option.loop = false;
        return option;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-promotion-images {
  // .content-title {
  //   margin-bottom: 24px;
  // }
  .wrap-image {
    width: 100%;
    height: 0;
    padding-bottom: 33.33%;
    position: relative;
  }
  .swiper-img {
    width: 100%;
    height: 340px;
    object-fit: cover;
    position: absolute;
  }
  .images-list {
    img {
      width: 800px;
      height: 340px;
      margin-bottom: 20px;
      cursor: pointer;
      border-radius: 24px;
      object-fit: cover;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .swiper-container {
    border-radius: 24px;
    .swiper-pagination-bullets {
      width: auto;
      left: calc((100% - 800px) / 2 + 32px);
      display: inline-flex;
      position: relative;
      top: -25px;
    }
    ::v-deep .swiper-pagination-bullet {
      width: 5px;
      height: 5px;
      background: #ffffff;
      border-radius: 3px;
      opacity: 0.5;
      margin: 0 2px;
    }
    ::v-deep .swiper-pagination-bullet-active {
      width: 10px;
      height: 5px;
      background: #ffffff;
      border-radius: 3px;
      opacity: 0.9;
    }
    .swiper-button-prev {
      left: calc((100% - 800px) / 2 + 20px);
      &:hover::after {
        background: url("../../../assets/images/banner-pre-active.png");
        background-size: 100% 100%;
      }
    }
    .swiper-button-next {
      right: calc((100% - 800px) / 2 + 20px);
      &:hover::after {
        background: url("../../../assets/images/banner-pre-active.png");
        background-size: 100% 100%;
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: block;
      width: 32px;
      height: 32px;
      top: calc(50% + 50px);
      transform: translateY(-100%);
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      background: url("../../../assets/images/banner-pre.png");
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      font-family: none;
      display: inline-block;
      content: "";
    }
    .swiper-button-next {
      top: calc(50% + 50px);
      transform: rotate(180deg) translateY(100%);
    }
  }
}

// 适配
.h5-promotion-images {
  // .content-title {
  //   margin-bottom: 0.43rem;
  // }
  .wrap-image {
    width: 100%;
    height: 0;
    padding-bottom: 33.33%;
    position: relative;
  }
  .swiper-img {
    width: 100%;
    height: 3.97rem;
    object-fit: cover;
    position: absolute;
  }
  .images-list {
    img {
      width: 100%;
      height: 3.97rem;
      margin-bottom: 0.27rem;
      border-radius: 0.32rem;
      object-fit: cover;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .swiper-container {
    border-radius: 0.32rem;
    .swiper-pagination-bullets {
      width: auto;
      left: 50%;
      transform: translate(-50%, 0);
      display: inline-flex;
    }
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
    .swiper-button-prev::after,
    .swiper-button-next::after {
      display: none;
    }
    ::v-deep .swiper-pagination-bullet {
      width: 0.08rem;
      height: 0.08rem;
      background: #000000;
      border-radius: 0.04rem;
      opacity: 0.3;
      margin: 0 0.05rem;
    }
    ::v-deep .swiper-pagination-bullet-active {
      width: 0.13rem;
      height: 0.08rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 0.04rem;
    }
  }
}
</style>
